import types from 'redux/types';

const pauseLoadHis = (data) => {
  return {
    type: types.REQUEST_PAUSE_LOAD_HISTORY,
    ...data,
  };
};

const getServlet = (data) => {
  return {
    type: types.REQUEST_API_SERVLET,
    ...data,
  };
};

const getPhoneNumbers = () => {
  return {
    type: types.REQUEST_PHONE_NUMBERS,
  };
};

const getCampaignData = () => {
  return {
    type: types.REQUEST_FILTER_CAMPAIGN,
  };
};

const pullRevenueData = () => {
  return {
    type: types.REQUEST_PULL_REVENUE_CAMPAIGN,
  };
};

const getMoreHistory = (data) => {
  return {
    type: types.REQUEST_MORE_HISTORY,
    ...data,
  };
};

const getHistoryByIds = (data) => {
  return {
    type: types.REQUEST_HISTORY_BY_ID,
    ...data,
  };
};

const clearServlet = () => {
  return {
    type: types.REQUEST_CLEAR_SERVLET,
  };
};

const sendInboxServlet = (sessionId, data) => {
  return {
    type: types.REQUEST_SEND_INBOX_SERVLET,
    sessionId,
    ...data,
  };
};

const sendServlet = (sessionId, data) => {
  return {
    type: types.REQUEST_SEND_SERVLET,
    sessionId,
    ...data,
  };
};

const spinServlet = (sessionId, data) => {
  return {
    type: types.REQUEST_SPIN_SERVLET,
    sessionId,
    ...data,
  };
};

const clearSpinServlet = () => {
  return {
    type: types.REQUEST_CLEAR_SPIN,
  };
};

const previewSpinTax = (sessionId, data) => {
  return {
    type: types.REQUEST_PREVIEW_SPIN,
    sessionId,
    ...data,
  };
};

const clearPreview = () => {
  return {
    type: types.REQUEST_CLEAR_PREVIEW_SPIN,
  };
};

const continueSendHist = (data) => {
  return {
    type: types.REQUEST_CONTINUE_HIST,
    ...data,
  };
};

const updateMessageHist = (data) => {
  return {
    type: types.REQUEST_UPDATE_MESSAGE_HIST,
    ...data,
  };
};

const markAsCompleteHist = (data) => {
  return {
    type: types.REQUEST_MARK_AS_COMPLETED,
    ...data,
  };
};

const refreshCampaign = (data) => {
  return {
    type: types.REQUEST_REFRESH_CAMPAIGN,
    ...data,
  };
};

const resendToFailedContacts = (data) => {
  return {
    type: types.REQUEST_RESEND_TO_FAILED_CONTACTS,
    ...data,
  };
};

const switchStatusRoute = (data) => {
  return {
    type: types.REQUEST_SWITCH_STATUS_ROUTE_HISTORY,
    ...data,
  };
};

const sortCampaign = (data) => {
  return {
    type: types.REQUEST_SORTING_CAMPAIGN,
    ...data,
  };
};

const setPhoneHistories = ({ nextHistories }) => {
  return {
    type: types.UPDATE_CAMPAIGN,
    history: nextHistories,
  };
};

export default {
  setPhoneHistories,
  sortCampaign,
  switchStatusRoute,
  resendToFailedContacts,
  refreshCampaign,
  getPhoneNumbers,
  getCampaignData,
  clearPreview,
  updateMessageHist,
  markAsCompleteHist,
  continueSendHist,
  pauseLoadHis,
  getMoreHistory,
  getServlet,
  clearServlet,
  sendServlet,
  sendInboxServlet,
  spinServlet,
  clearSpinServlet,
  previewSpinTax,
  getHistoryByIds,
  pullRevenueData,
};
